import React, { useEffect, useRef, useState } from 'react';

const MAPBOX_SCRIPT = 'https://api.mapbox.com/mapbox-gl-js/v2.1.1/mapbox-gl.js';
const MAPBOX_CSS = 'https://api.mapbox.com/mapbox-gl-js/v2.1.1/mapbox-gl.css';

function ensureMapboxAssets(onReady) {
    if (!document.querySelector(`link[href="${MAPBOX_CSS}"]`)) {
        const link = document.createElement('link');
        link.href = MAPBOX_CSS;
        link.rel = 'stylesheet';
        document.head.appendChild(link);
    }

    if (window.mapboxgl) {
        onReady();
        return;
    }

    let script = document.querySelector(`script[src="${MAPBOX_SCRIPT}"]`);
    if (!script) {
        script = document.createElement('script');
        script.src = MAPBOX_SCRIPT;
        script.async = true;
        document.body.appendChild(script);
    }
    script.addEventListener('load', onReady, { once: true });
}

function MapboxMap({ kantorData }) {
    const mapContainerRef = useRef(null);
    const [isReady, setIsReady] = useState(() => typeof window !== 'undefined' && Boolean(window.mapboxgl));

    useEffect(() => {
        ensureMapboxAssets(() => setIsReady(true));
    }, []);

    useEffect(() => {
        if (!isReady || !mapContainerRef.current || !window.mapboxgl) return undefined;

        const mapboxgl = window.mapboxgl;
        mapboxgl.accessToken = 'pk.eyJ1IjoiaGlzeWFtYnNhIiwiYSI6ImNtMHQzNWFpYjBvcGQyanM1Z2tybXZyenkifQ.0-oa8XfRcL1HDegsveqUjQ';

        const map = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: 'mapbox://styles/mapbox/dark-v10',
            center: [106.85508361946768, -6.226420573043901],
            zoom: 13,
        });

        kantorData.forEach((kantor) => {
            const lat = Number(kantor.latitude);
            const lng = Number(kantor.longitude);
            if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

            const popup = new mapboxgl.Popup({ offset: 24, closeButton: false }).setHTML(`
                <div style="font-family:Arial,sans-serif;color:#0f172a;max-width:220px">
                    <strong>${kantor.nama_kantor || 'PT Len Telekomunikasi Indonesia'}</strong>
                    <div style="margin-top:6px;font-size:12px;line-height:1.5">${kantor.alamat || ''}<br>${kantor.kota || ''} ${kantor.kode_pos || ''}</div>
                </div>
            `);

            new mapboxgl.Marker().setLngLat([lng, lat]).setPopup(popup).addTo(map);
        });

        return () => map.remove();
    }, [isReady, kantorData]);

    return (
        <div className="relative h-[360px] w-full sm:h-[430px]">
            {!isReady && <div className="absolute inset-0 z-10 animate-pulse bg-slate-800" />}
            <div ref={mapContainerRef} className="h-full w-full" />
        </div>
    );
}

export default MapboxMap;
